export default __webpack_public_path__ + "static/media/P348_SOV.6c03fd02.pdf";